import "./StackedQuestionnaireActions.css";
import type { DOMProps } from "@simplybusiness/mobius";
import type { Ref } from "react";
import { useQuestionnaire } from "../../../../features/questionnaire";
import { useShouldBlockSubmission } from "../../../../hooks/useShouldBlockSubmission";
import { QuestionnaireActions } from "../QuestionnaireActions";
import type { BaseQuestionnaireActionsProps, ActionsElement } from "../index";

export type StackedQuestionnaireActionsProps = BaseQuestionnaireActionsProps &
  DOMProps & {
    /** Ref to the underlying HTMLDivElement */
    ref?: Ref<ActionsElement>;
  };
export type StackedQuestionnaireActionsRef = Ref<ActionsElement>;

/**
 * Stacked questionnaire actions variant with submit and back actions.
 */
export const StackedQuestionnaireActions = (
  props: StackedQuestionnaireActionsProps,
) => {
  const { submitActionLabel, backAction, ref } = props;

  // Access state via hooks
  const { errors } = useQuestionnaire();
  const shouldBlockSubmission = useShouldBlockSubmission();

  return (
    <QuestionnaireActions ref={ref} className="--stacked">
      {backAction && (
        <QuestionnaireActions.Back
          label={backAction.label}
          href={backAction.url}
        />
      )}
      <QuestionnaireActions.Submit
        buttonLabel={submitActionLabel}
        isDisabled={shouldBlockSubmission}
        errors={errors}
      />
    </QuestionnaireActions>
  );
};
